import React from 'react';
import './FeatureCard.css';

const FeatureCard = ({ icon, title, description, accent = 'default', className = '', index = 0 }) => {
  const classes = ['feature-card', `feature-card--${accent}`, className].filter(Boolean).join(' ');

  return (
    <article className={classes} style={{ '--feature-index': index }}>
      <div className="feature-card__icon">{icon}</div>
      <div className="feature-card__body">
        <h3 className="feature-card__title">{title}</h3>
        <p className="feature-card__description">{description}</p>
      </div>
    </article>
  );
};

export default FeatureCard;
